/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  ProductDraftsUserControllerFindOneQueryResponse,
  ProductDraftsUserControllerFindOnePathParams,
  ProductDraftsUserControllerFindOne401,
  ProductDraftsUserControllerFindOne404,
} from '../types/ProductDraftsUserControllerFindOne.ts';

function getProductDraftsUserFindOneUrl(id: ProductDraftsUserControllerFindOnePathParams['id']) {
  const res = { method: 'GET', url: `/api/user/product-drafts/${id}` as const };
  return res;
}

/**
 * {@link /api/user/product-drafts/:id}
 */
export async function productDraftsUserFindOne(
  id: ProductDraftsUserControllerFindOnePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    ProductDraftsUserControllerFindOneQueryResponse,
    ResponseErrorConfig<ProductDraftsUserControllerFindOne401 | ProductDraftsUserControllerFindOne404>,
    unknown
  >({ method: 'GET', url: getProductDraftsUserFindOneUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
